import React from "react";

import { Text, textPropTypes } from "../Text";

/** The Emphasis component renders emphasized text. */
export const Em = (props) => <Text element="em" italics {...props} />;

Em.displayName = "Em";

Em.propTypes = textPropTypes;
